import React from 'react';
import { Link } from 'react-router-dom';

import MapImage from '../../assets/map-image.jpg';

const StoryBlock = () => (
    <div className="block-item block-item--story clearfix">
        <h2 className="block-item__title large--three-twelfths">Our Story</h2>

        <div className="block-item__inner large--nine-twelfths">
            <div className="block-item__image">
                <img width="815" height="405" src={MapImage} className="attachment-full size-full" alt="" />
            </div>

            <div className="block-item__content">
                <p>Established in 2012, Hubton Indonesia has served clients from various sectors over the globe. Started small in a tiny studio in Jakarta, Hubton now has ten people on board, based in Bandung and has been acknowledged in the country and internationally.</p>
                <p>Contributing in an Australian award-winning website production, invited by Government to contribute in legislation, lecture in Graphic Design and UI/UX Design, inaugurated as Program Director of ADGI Bandung, and has been featured in Harian Tribun Jabar newspaper.</p>
                <p>We love to work with our team that our studio has been our second home. Can we catch up with you there and see what you have in mind?</p>
            </div>

            <div className="block-item__footer">
                <Link to="/visit-hubton-studio" className="block-item__link underlined-link">
                    Visit Our Studio →
                </Link>
            </div>
        </div>
    </div>
);

export default StoryBlock;



// WEBPACK FOOTER //
// ./src/containers/About/StoryBlock.js